export default __webpack_public_path__ + "static/media/icon_building.8e5bb7ef.svg";